import {Template} from "../../../components/template/template.jsx";
import HeaderButtons from "../../../components/reports/report-menu/header-buttons.jsx";
import React, {useEffect, useRef, useState} from "react";
import Menu from "../../../components/reports/report-menu/menu.jsx";
import Filters from "./components/filters.jsx";
import {Card} from "../../../components/card/card.jsx";
import NotAppliedContent from "../../../components/reports/report-menu/not-applied-content.jsx";
import NoDataContent from "../../../components/reports/report-menu/no-data-content.jsx";
import Content from "./components/content/content.jsx";
import {useGlobalKey} from "../../../hooks/use-global-key.js";
import ReportUtils from "../../../utils/report-utils.js";
import attendanceQualityService from "../../../services/reports/attendance-quality-service.js";
import reportUtils from "../../../utils/report-utils.js";
import projectUtils from "../../../utils/project-utils.js";
import {endOfDay, startOfDay, subDays} from "date-fns";
import SubScroll from "../../../components/sub-scroll/sub-scroll.jsx";
import AutoDatetime from "../../../components/reports/auto-datetime/auto-datetime.jsx";

const refDate = new Date();

const initialFilters = {
  dtStart: subDays(refDate, 7),
  dtEnd: refDate,
  hrStart: startOfDay(refDate),
  hrEnd: endOfDay(refDate),
  attendant: [],
  options: [],
  attendantList: false,
  period: {value: "all", label: "Todos"}
}

const filterLabels = {
  dtStart: "Data inicial",
  dtEnd: "Data final",
  hrStart: "Hora inicial",
  hrEnd: "Hora final",
  options: "Indicadores de Preenchimento",
  attendant: "Atendentes",
  attendantList: "Listar atendimento",
  period: "Período",
};
const AttendanceQuality = () => {
  const [loading, setLoading] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [fixedTop, setFixedTop] = useState(null);
  const [filters, setFilters] = useState(initialFilters);
  const [reportData, setReportData] = useState(null);
  const [title] = useState("Qualidade do atendimento");
  const [headerSelected, setHeaderSelected] = useState(-1);
  const [auditFilters, setAuditFilters] = useState(null);
  const [listAttendants, setListAttendants] = useState(false);
  const buttonRef = useRef(null);
  const printComponentRef = useRef(null);
  const formatTimeForPrint = (date) => projectUtils.formatTimeString(date)?.slice(0, 5) ?? "";
  const toggleFilters = () => {
    if (!collapsed && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setFixedTop(rect.top);
    }

    setCollapsed(prev => !prev);
  }


  const apply = async () => {
    ReportUtils.applyLoad({
      setLoading,
      clearContent: () => {
        setReportData(null);
      }
    });

    const isNotValidDt = reportUtils.validateOnlyDates(filters.dtStart, filters.dtEnd, 1, 'year');
    if(!isNotValidDt.ok){
      projectUtils.swalErrorMessage("", isNotValidDt.message, "Ok");
      setLoading(false);
      return;
    }

    const isNotValid = reportUtils.validateTimeString(filters.hrStart, filters.hrEnd);
    if(!isNotValid.ok){
      projectUtils.swalErrorMessage("", isNotValid.message, "Ok");
      setLoading(false);
      return;
    }

    const isNotValidPeriod = reportUtils.requiredFilterValidate(filters.options, "Indicadores de Preenchimento", setLoading);

    if(!isNotValidPeriod){
      return;
    }

    try {
      const formattedFilters = {
        dtStart: filters.dtStart ? ReportUtils.formatDateOnly(filters.dtStart) : null,
        dtEnd: filters.dtEnd ? ReportUtils.formatDateOnly(filters.dtEnd) : null,
        hrStart: filters.hrStart ? projectUtils.formatTimeString(filters.hrStart) : null,
        hrEnd: filters.hrEnd ? projectUtils.formatTimeString(filters.hrEnd) : null,
        attendantList: filters.attendantList ? "Sim" : "Não"
      };

      const auditFilters = ReportUtils.filters({
          dtStart: formattedFilters.dtStart,
          dtEnd: formattedFilters.dtEnd,
          attendantList: formattedFilters.attendantList,
          hrStart: formattedFilters.hrStart,
          hrEnd: formattedFilters.hrEnd},
        filterLabels, true);

      setAuditFilters(formattedFilters);

      const  data = await attendanceQualityService.apply({
        ...buildPayload(filters),
        filters: auditFilters
      })


      setListAttendants(filters.attendantList);
      setReportData(data);

      const scale = window.visualViewport?.scale ?? 1;
      if (window.innerWidth <= 1440 || scale > 1) setCollapsed(true);

    } catch (error) {

      ReportUtils.alertErrorMessage("Erro ao gerar o relatório.");
      console.error("Erro ao gerar o relatório", error);

    } finally {
      setLoading(false);
    }
  }

  const clearSearch = () => {
    setFilters(initialFilters);
    setReportData(null);
  }

  useGlobalKey("Enter", apply);
  useGlobalKey("Escape", clearSearch);

  function buildPayload(data){
    const payload = {
      dtStart: reportUtils.formatDateOnly(data.dtStart),
      dtEnd: reportUtils.formatDateOnly(data.dtEnd),
      hrStart: projectUtils.formatTimeString(filters.hrStart),
      hrEnd: projectUtils.formatTimeString(filters.hrEnd),
      options: data.options.map(el => el.value),
      attendant: data.attendant
    }

    if(data.attendantList){
      payload.attendantList = "on";
    }

    return payload
  }

  useEffect(() => {
    if (!reportData) return;

    ReportUtils.appendFilters(
      ReportUtils.filters({
        ...filters,
        dtStart: filters.dtStart ? ReportUtils.formatDateOnly(filters.dtStart) : "",
        dtEnd: filters.dtEnd ? ReportUtils.formatDateOnly(filters.dtEnd) : "",
        hrStart: formatTimeForPrint(filters.hrStart),
        hrEnd: formatTimeForPrint(filters.hrEnd),
        period: reportUtils.periods().find(el => el.value === filters.period.value).label
      }, filterLabels)
    );

  }, [reportData]);

  return(
    <SubScroll dependency={[collapsed, reportData]}>
      <div className="flex">
        <Template isLoading={loading}>
          <Template.Header>
            <div className="flex justify-between w-full">
              <Template.Title>{title}</Template.Title>
              <HeaderButtons
                exportable={true}
                exportInSheets={true}
                printable={true}
                headerChange={true}
                printComponentRef={printComponentRef}
                reportData={reportData}
                data={reportData?.attendance_list.length}
                headerSelected={headerSelected}
                setHeaderSelected={setHeaderSelected}
              />
            </div>
          </Template.Header>
          <Template.Body className={`${collapsed ? 'p-[0]' : ''}`}>
            <Menu buttonRef={buttonRef} fixedTop={fixedTop} toggleFilters={toggleFilters}
                  collapsed={collapsed} apply={apply} clearSearch={clearSearch}>

              <Filters setFilters={setFilters} filters={filters}/>
              <AutoDatetime setFilters={setFilters}/>
            </Menu>
          </Template.Body>
        </Template>

        <Card className={`w-full h-fit mr-2 ${!reportData || reportData?.attendance_list?.length === 0 ? 'mt-[59px]' : 'mt-[61px]' } print:!mt-[-15px] transform ${!reportData || reportData?.attendance_list?.length === 0 ? '!bg-[#f3f3f4] !border-none !-translate-y-[5px]' : ''} ${collapsed ? 'ml-2' : ''}`}>
          <Card.Body>
            <div className={`flex-1 ${!reportData ? 'p-[0]' : 'px-[20px] py-[5px]'}`}>
              <NotAppliedContent reportData={reportData}/>
              <NoDataContent reportData={reportData} data={reportData?.attendance_list?.length}/>
              <Content filters={auditFilters} reportData={reportData} data={reportData?.attendance_list} entity={headerSelected} title={title} collapsed={collapsed} setLoading={setLoading} printComponentRef={printComponentRef} listAttendants={listAttendants}/>
            </div>
          </Card.Body>
        </Card>
      </div>
    </SubScroll>
  )
}

export default AttendanceQuality;